<div class="paste-area" (paste)="handlePaste($event)" *ngIf="!this.image"
     (click)="onClick()"
     (mouseleave)="onBlur()">
    <span *ngIf="focused"
          class="message ok"> {{ 'admin.strain.common.excelPaste.copyPasteGraph.focused' | translate }}</span>
    <span *ngIf="!focused"
          class="message not-ok">{{ 'admin.strain.common.excelPaste.copyPasteGraph.notFocused' | translate }}</span>
</div>

<canvas id="canvas" [hidden]="!this.image"></canvas>

<app-button type="primary" (click)="handleReset()" *ngIf="image">
    <i class="fa fa-undo"></i>
</app-button>
